// extracted by mini-css-extract-plugin
export default {"tooltip":"Oo-z","sharingV2":"Po-z","sharingIconsV2":"Qo-z","links":"Ro-z","link":"So-z","facebookV2":"To-z","twitterV2":"Uo-z","pinterestV2":"Vo-z"};